import { useAction } from "@framework/shared/hooks/useAction";
import { useCallback, useEffect, useRef, useState } from "react";

type ActivityType = "lesson" | "assessment" | "offer" | "resource";

export function useTrackActivityView(
  type: ActivityType,
  typeId: string | number,
  title?: string,
): void {
  const submit = useAction("/activities/view");
  const isSentRef = useRef(false);
  const [currentTypeId, setCurrentTypeId] = useState(typeId);

  const trackActivityView = useCallback(async () => {
    try {
      if (isSentRef.current) return;
      isSentRef.current = true;

      const payload = {
        subType: type,
        typeId: currentTypeId.toString(),
        title,
      };

      await submit(payload);
    } catch (error) {
      console.error(`Failed to track ${type} view:`, error);
      // Don't throw error to avoid breaking user experience
    }
  }, [type, currentTypeId, submit]);

  useEffect(() => {
    if (typeId !== currentTypeId) {
      isSentRef.current = false;
      setCurrentTypeId(typeId);
    }
  }, [currentTypeId, typeId]);

  useEffect(() => {
    trackActivityView();
  }, [currentTypeId]);
}
